// Escape HTML so AI-generated / user-derived text can't inject markup when we
// render lightweight markdown via dangerouslySetInnerHTML. Always escape the
// RAW text first, then apply the (trusted) markdown-to-tag transforms.
export function escapeHtml(t) {
  return String(t ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
